import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const ComlaintQuery = async (data) => {
  try {
    const res = await postData(`/without-login/complaint/query`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const GetComlaintQuery = async (id) => {
  try {
    const res = await getData(`/without-login/complaint/get-query/${id}`);

    return res;
  } catch (error) {
    console.log(error);
  }
};
